import { HeroProps } from "@/components/hero";

export const HERO_CONSTANTS: HeroProps["list"] = [
  {
    title: "Empower Your Business with Scalable Cloud Solutions ",
    content:
      "Seamlessly deploy, manage, and optimize your IT infrastructure with Onemind's Cloud Services. Whether you need a private cloud for secure workloads or POC cloud for testing and innovation, we deliver tailored solutions to accelerate your digital transformation. ",
    button: {
      label: "Start your cloud journey today! ",
      link: "#contact-us",
    },
  },
];
